import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import formFieldsSelectors from '../store/selectors/form-fields.selectors';
import { FieldData } from '../types/form.types';

const useReasons = (): {
  detailReasonValue: string;
  isReasonFilled: boolean;
  mainReason?: FieldData;
  mainReasonValue: string;
  detailReason: FieldData | null;
  showAttachment: boolean;
} => {
  const { case_reason, case_detailed_reason } = useSelector(
    formFieldsSelectors.getReasons
  );
  const getFieldValue = useSelector(formFieldsSelectors.getFieldValue);
  const attachmentVisible = useSelector(
    formFieldsSelectors.getAttachmentVisible
  );
  const mainReasonValue = getFieldValue('case_reason');
  const detailReasonValue = getFieldValue('case_detailed_reason');

  const caseDetailedReasonOptions =
    mainReasonValue &&
    case_detailed_reason?.options &&
    !Array.isArray(case_detailed_reason.options) &&
    case_detailed_reason.options[mainReasonValue]
      ? case_detailed_reason.options[mainReasonValue]
      : undefined;

  const mainReason = case_reason
    ? ({ ...case_reason, name: 'case_reason' } as FieldData)
    : undefined;

  const detailReason = caseDetailedReasonOptions
    ? ({
        ...case_detailed_reason,
        name: 'case_detailed_reason',
        options: caseDetailedReasonOptions
      } as FieldData)
    : null;

  const isReasonFilled = useMemo(() => {
    return (
      !!(mainReasonValue && detailReasonValue) ||
      !!(mainReasonValue && !detailReason?.options)
    );
  }, [detailReason?.options, detailReasonValue, mainReasonValue]);

  const showAttachment = !!attachmentVisible;

  return {
    mainReason,
    mainReasonValue,
    detailReason,
    detailReasonValue,
    isReasonFilled,
    showAttachment
  };
};

export default useReasons;
